export default [
  "xy",
  "tenkafuma",
  "legeclo",
  "xfs",
  "mnsg",
  "mistytm",
  "monmusu",
  "panjiya",
  "jsmn",
  "ragnador",
  "ssmx",
  "kga",
  "tenkei-paradox",
  "angelic",
  "unitia",
  "xysn",
  "yshx"
];
